<template>
  <div  class="home-gstock container">
    <div class="btn btn-1" @click="$router.push({ name: 'clients'})">
      <svg>
        <rect x="0" y="0" fill="none" width="100%" height="100%"/>
      </svg>
     CLIENTS
    </div>
    <div @click="$router.push({ name: 'products'})" class="btn btn-1">
      <svg>
        <rect x="0" y="0" fill="none" width="100%" height="100%"/>
      </svg>
     ARTICLES
    </div>
    <!-- <div class="btn btn-5">CLIENTS</div>
    <div class="btn btn-5">PRODUITS</div> -->
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
  .md-theme-default {
    background-color: transparent !important;
  }
</style>
<style lang="scss" scoped>

// @import url(https://fonts.googleapis.com/css?family=Roboto:400, 100, 900);
* {
  box-sizing: inherit;
  transition-property: all;
  transition-duration: 0.6s;
  transition-timing-function: ease;
}
//colors
$red: #f8f9fe;
$white: #fff;
.container { 
    margin-top: 20%;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1em;
    text-align: center; 
    
    @media (min-width: 600px) {
        flex-direction: row;
        justify-content: space-between;
    }
}
.btn {
  color: #fff;
  cursor: pointer;
  // display: block;
  font-size:16px;
  font-weight: 400;
  line-height: 150px;
  height: 150px;
  margin: 0 0 2em;
  max-width: 400px; 
  position: relative;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%; 
  padding: 0rem 1.25rem;
  
//   @media(min-width: 400px) {
//     display: inline-block;
//     margin-right: 2.5em;
  
//     &:nth-of-type(even) {
//       margin-right: 0;
//     }
//   }
  
  @media(min-width: 600px) {
      
    margin: 0 1em 2em;
  
//     &:nth-of-type(even) {
//       margin-right: 2.5em;
//     }
    
//     &:nth-of-type(5) {
//       margin-right: 0;
//     }
    
  }
  
  &:hover { text-decoration: none; }
  
}
.btn-1 {
  background: #000;
  font-weight: 100;
  
  svg {
    height: 150px;
    left: 0;
    position: absolute;
    top: 0; 
    width: 100%; 
  }
  
  rect {
    fill: none;
    stroke: #000;
    stroke-width: 2;
    stroke-dasharray: 422, 0;
    transition: all 0.35s linear;
  }
}

.btn-1:hover {
  background: rgba($red, 0);
  font-weight: 900;
  letter-spacing: 1px;
  color: #000;
  
  rect {
    stroke-width: 5;
    stroke-dasharray: 15, 310;
    stroke-dashoffset: 48;
    transition: all 1.35s cubic-bezier(0.19, 1, 0.22, 1);
  }
}

// .home-gstock {
//   background: #f3f3f3;
//   width: 100%;
//   height: 100vh;
//   display: flex;
//   flex-flow: column nowrap;
//   justify-content: center;
//   align-items: center;
//   .btn {
//     background: #000;
//     border-bottom: 1px solid;
//     color: $white;
//     line-height: 1.4;
//     padding: 0.25em;
//     text-decoration: none;

//     &:hover {
//       background: rgba($white, 1);
//       color: #000;
//     }
//     color: #fff;
//     cursor: pointer;
//     font-size: 16px;
//     font-weight: 400;
//     line-height: 45px;
//     margin: 0 0 2em;
//     max-width: 250px;
//     // height: 100px;
//     position: relative;
//     text-decoration: none;
//     text-transform: uppercase;
//     width: 100%;
//     @media (min-width: 600px) {
//       margin: 0 1em 2em;
//     }

//     &:hover {
//       text-decoration: none;
//     }
//   }
//   .btn-5 {
//     border: 0 solid;
//     box-shadow: inset 0 0 20px rgba(255, 255, 255, 0);
//     outline: 1px solid;
//     outline-color: rgba(255, 255, 255, 0.5);
//     outline-offset: 0px;
//     text-shadow: none;
//     transition: all 1250ms cubic-bezier(0.19, 1, 0.22, 1);
//   }

//   .btn-5:hover {
//     border: 1px solid;
//     box-shadow: inset 0 0 20px rgba(255, 255, 255, 0.5),
//       0 0 20px rgba(255, 255, 255, 0.2);
//     outline-color: rgba(255, 255, 255, 0);
//     outline-offset: 15px;
//     text-shadow: 1px 1px 2px #427388;
//   }
// }
</style>